import type { RoleType } from './roles';

const PHI_EDIT_BLOCKED: readonly RoleType[] = ['customer_support', 'org_user', 'client'];

/**
 * PHI updates (PATCH /clients/:id with PHI fields) are blocked server-side
 * for non-clinical roles. Mirror that here so the FE never offers the action.
 * Pair with `hasPermission('client:update')` at call sites — this helper
 * does not check the underlying update permission.
 */
export function canEditPhi(role: RoleType | null): boolean {
  return role !== null && !PHI_EDIT_BLOCKED.includes(role);
}
